export const REGEX_EVM_ADDRESS = /0x[0-9a-f]{40}/i;
export const REGEX_SOL_ADDRESS = /[1-9A-HJ-NP-Za-km-z]{32,44}/;
